import { defineStore } from 'pinia'
import { getDataLang } from '../helpers/api'

export interface IDiningMenu {
  title: string
  url: string
  order: number
}

export interface IDinings {
  dining_title: string
  dining_operational_hours: string
  dining_breakfast_time: string
  dining_custom_url: string
  dining_image: string
  is_placeholder_image?: boolean
  dining_menu: IDiningMenu[] | null
  dining_description: string
  reserve_link: string
}

export interface IDiningsState {
  list: IDinings[]
}

export const useDiningsStore = defineStore('dinings', {
  state: (): IDiningsState => ({
    list: [],
  }),
  getters: {
    getList(): IDiningsState['list'] {
      return getDataLang(this.list, 0, 'dining')
    },
  },
  actions: {
    setList(data: IDinings[]) {
      this.list = data
    },
  },
})
